import type { ButtonHTMLAttributes } from 'react';

type Variant = 'primary' | 'gold' | 'moss' | 'ghost';

export function PixelButton({
  variant = 'primary',
  className,
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant }) {
  const cls = [
    'pixel-btn',
    variant === 'gold' && 'pixel-btn--gold',
    variant === 'moss' && 'pixel-btn--moss',
    variant === 'ghost' && 'pixel-btn--ghost',
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return <button type="button" {...rest} className={cls} />;
}
